function compactText(value) {
  return String(value || "").replace(/\s+/g, " ").trim();
}

export function providerReasonFromRow(row = {}) {
  const response = row.response || row.provider_response || {};
  const nestedResponse = response?.response || {};
  const candidates = [
    row.provider_reason,
    response.provider_reason,
    response.reason,
    response.message,
    nestedResponse.message,
    nestedResponse.error,
    row.admin_note,
    row.note,
  ];
  const reason = compactText(candidates.find((value) => compactText(value)));
  if (!reason) return "";
  const providerReasonMatch = reason.match(/provider reason:\s*([^;]+)/i);
  if (providerReasonMatch?.[1]) return compactText(providerReasonMatch[1]);
  const failedMatch = reason.match(/provider rejected\/failed the load:\s*(.+?)(?:\. Wallet|$)/i);
  if (failedMatch?.[1]) return compactText(failedMatch[1]);
  return reason;
}

export function playerFriendlyProviderReason(reason = "") {
  const clean = compactText(reason);
  const lower = clean.toLowerCase();
  if (!clean) return "";
  if (
    lower.includes("player is still in the game") ||
    lower.includes("still in the game") ||
    lower.includes("return to the game lobby") ||
    lower.includes("exit to the lobby") ||
    lower.includes("inside the game")
  ) {
    return "The game provider rejected this because the player is still inside the game. Please exit to the game lobby or fully close the game app, tap Refresh balance, then try again.";
  }
  return clean;
}

export function gameLoadFailureMessage(row = {}) {
  const friendly = playerFriendlyProviderReason(providerReasonFromRow(row));
  return friendly || "Load failed and wallet/freeplay was refunded automatically.";
}
